"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { isNativeAppClient } from "@/lib/native-app";

function isAuthPath(pathname: string) {
  return (
    pathname === "/login" ||
    pathname === "/register" ||
    pathname.startsWith("/login/") ||
    pathname.startsWith("/register/")
  );
}

/** Keeps the native-app hide rules after client navigations. First paint is the boot script. */
export function NativeAppChrome() {
  const pathname = usePathname();

  useEffect(() => {
    const native = isNativeAppClient();
    const root = document.documentElement;
    root.classList.toggle("chatisafe-native", native);
    const auth = native && isAuthPath(pathname);
    root.classList.toggle("chatisafe-native-auth", auth);
    if (!native) return;
    if (pathname === "/") {
      window.location.replace("/dashboard?csapp=1");
      return;
    }
    try {
      localStorage.setItem("chatisafe-native", "1");
    } catch {
      /* ignore */
    }
    let style = document.getElementById("chatisafe-native-style");
    if (!style) {
      style = document.createElement("style");
      style.id = "chatisafe-native-style";
      document.head.appendChild(style);
    }
    style.textContent =
      ".cookie-banner{display:none!important}" +
      (auth ? "[data-site-header],header.fixed{display:none!important}#main-content{padding-top:1.5rem!important}" : "");
  }, [pathname]);

  return null;
}
